import React from "react";
import Row from "../Row";

class Accordian extends React.Component {

    componentDidMount() {

    }

    render() {
        return (
          <section className="rob-accordian">
              <div className="container">
                  <div className="row">
                      <div className="col-12">
                          {this.props.accordian.map(function (name, index) {
                              return  <Row key={index} {...name} />
                          })
                          }
                      </div>
                  </div>
              </div>
          </section>
        )
    }
}

Accordian.defaultProps = {accordian: []};

export default Accordian;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/Accordian.js